import PublicIcon from '@material-design-icons/svg/filled/public.svg?react';
import {
  getTicketGeofilteringDisplay,
  type TicketGeofilteringMode,
} from './geofiltering';

interface HubspotTicketGeofilteringNoticeProps {
  availableCountriesMode: TicketGeofilteringMode;
  availableCountries: string[];
}

export function HubspotTicketGeofilteringNotice({
  availableCountriesMode,
  availableCountries,
}: HubspotTicketGeofilteringNoticeProps) {
  const geofiltering = getTicketGeofilteringDisplay(
    availableCountriesMode,
    availableCountries,
  );

  if (!geofiltering) {
    return null;
  }

  return (
    <div className="rounded-lg border border-amber-500/25 bg-amber-500/[0.07] px-4 py-3">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-amber-100">
          <PublicIcon className="size-4 fill-current text-amber-300" />
          <span>Geofiltering enabled</span>
        </div>
        <span className="rounded-md border border-amber-500/20 bg-amber-500/10 px-2 py-0.5 text-xs font-medium text-amber-200">
          {geofiltering.label}
        </span>
      </div>
      <div className="mt-2 text-sm text-neutral-200">
        {geofiltering.summary}
      </div>
      <div className="mt-1 max-h-24 overflow-y-auto text-sm leading-6 text-neutral-300 custom-scrollbar">
        {geofiltering.countryNames}
      </div>
    </div>
  );
}
